export function formatWon(value) {
    const isValidString = typeof value === 'string' && /^\s*[0-9][0-9,\s]*원?\s*$/.test(value);
    const amount = typeof value === 'number'
        ? value
        : (isValidString ? Number(value.replace(/[^0-9]/g, '')) : NaN);
    return Number.isSafeInteger(amount) && amount >= 0 ? `${amount.toLocaleString('ko-KR')}원` : '-';
}
